export enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_promptModals = '#placeholder-for-promptModals',
    promptYesNoModal = '#promptYesNoModal',
    promptModalYesBtn = '#promptModalYesBtn',
    CAMSMainPage_LeftPanels = '#CAMSMainPage_LeftPanels',
    CAMSMainPage_RightPanels = '#CAMSMainPage_RightPanels',
    CAMSMainToolbar_Container = '#CAMSMainToolbar_Container',
    officerMapContainer = '#officerMapContainer',

    mainAppToolbar = '#mainAppToolbar',
    navbarNavDropdown = '#navbarNavDropdown',
    navbarNavSelectedTitle = '#navbarNavSelectedTitle',
    authModel = '#authModel',
    mainAppConfigModel = '#mainAppConfigModel',
    layerPanel = '#layerPanel',
    layersBtn = '#layersBtn',
    legendBtn = '#legendBtn',
    zoomBtn = '#zoomBtn',
    mapInfoSelectBtn = '#mapInfoSelectBtn',
    mapFeatureSelectBtn = '#mapFeatureSelectBtn',
    featureDetailsPanel = '#featureDetailsPanel',
    searchBtn = '#searchBtn',
    searchPanel = '#searchPanel',
    additionalMapToolsBtn = '#additionalMapToolsBtn',
    additionalMapToolsPanel = '#additionalMapToolsPanel',
    additionalMapToolsCloseBtn = '#additionalMapToolsCloseBtn',
    reportAnIssue_MyIssuesBtn = '#reportAnIssue_MyIssuesBtn',
    reportAnIssue_CreateBtn = '#reportAnIssue_CreateBtn',
    reportAnIssue_CreateMobileBtn = '#reportAnIssue_CreateMobileBtn',
    mapTreeSelectBtn = '#mapTreeSelectBtn',
    recordListBtn = '#recordListBtn',
    newMaintBtn = '#newMaintBtn',
    newInfraBtn = '#newInfraBtn',
    newLandBtn = '#newLandBtn',
    newRouteBtn = '#newRouteBtn',
    newPathBtn = '#newPathBtn',
    newTaskBtn = '#newTaskBtn',
    newTaskBtnOnTasks = '#newTaskBtnOnTasks',
    myTasksRecordListBtn = '#myTasksRecordListBtn',
    taskManagementRecordListBtn = '#taskManagementRecordListBtn',
    submissionListPanelBtn = '#submissionListPanelBtn',
    legalEventsBtn = '#legalEventsBtn',
    newLegalEventsBtn = '#newLegalEventsBtn',
    consultationsBtn = '#consultationsBtn',
    consultationsRegisterBtn = '#consultationsRegisterBtn',
    headerHome = '#headerHome',
    headerReportanIssue = '#headerReportanIssue',
    headerTrustedMap = '#headerTrustedMap',
    headerMyTasks = '#headerMyTasks',
    headerTaskManagement = '#headerTaskManagement',
    headerSubmissions = '#headerSubmissions',
    headerConsultations = '#headerConsultations',
    headerLegalEvents = '#headerLegalEvents',
    headerLand = '#headerLand',
    headerContacts = '#headerContacts',
    headerAnnotations = '#headerAnnotations',
    headerTRO = '#headerTRO',
    selectListCannotFindFeatureModal = '#selectListCannotFindFeatureModal',
    selectListPanel = '#selectListPanel',
    mapButtonsPanel = '#mapButtonsPanel',
    mapMessageContainer = '#mapMessageContainer',
    infoDetailsPanel = '#infoDetailsPanel',
    reportAnIssueMyIssuesPanel = '#reportAnIssueMyIssuesPanel',
    reportAnIssueNewMaintPanel = '#reportAnIssueNewMaintPanel',
    annotationsListBtn = '#annotationsListBtn',
    annotationsNewBtn = '#annotationsNewBtn',
    annotationsReportBtn = '#annotationsReportBtn',
    troListBtn = '#troListBtn',
    troNewBtn = '#troNewBtn',
    languageSwitchBtn = '#languageSwitchBtn',
    notificationPanelContainer = '#notificationPanelContainer',
    _layoutHeaderHelpIcon = "#_layoutHeaderHelpIcon",
    _layoutHeaderNotifationListIcon = '#_layoutHeaderNotifationListIcon',
    newFeatureBtn = '#newFeatureBtn',
    newFeaturePanel = '#newFeaturePanel',
    contactsBtn = '#contactsBtn'
}
